export function formatToUSD(value, abbreviate = false) {
  if (typeof value !== 'number') {
    value = 0
  }

  if (abbreviate) {
    const suffixes = ['', 'K', 'M', 'B', 'T']; // Abreviações: mil, milhão, bilhão, trilhão
    let tier = Math.floor(Math.log10(Math.abs(value)) / 3); // Determina a magnitude
    tier = Math.min(tier, suffixes.length - 1); // Garante que não ultrapasse os limites

    const scaledValue = value / Math.pow(10, tier * 3); // Reduz o valor para a escala apropriada
    const suffix = suffixes[tier]; // Seleciona o sufixo apropriado

    return `${scaledValue.toFixed(2)}${suffix} USD`; // Retorna o valor abreviado
  }

  const truncated = Math.floor(value * 100) / 100;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(truncated);
}
